// export default PaymentMethods;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  defaultPaymentCard,
  deletePaymentCard,
  fetchMyCards,
  selectPaymentCards,
} from "../store/slices/methodePaymentSlice";
import {
  Elements,
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import FormAjoutCarte from "./FormAjoutCarte";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import { create } from "../services/services";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentMethods = () => {
  const [showAjoutCard, setShowAjoutCard] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null); // 'success' or 'error'
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const cards = useSelector(selectPaymentCards);
  // console.log("cards", cards);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchMyCards())
      .unwrap()
      .finally(() => setLoading(false));
  }, []);

  const handleAddClick = () => {
    setShowAjoutCard(true);
  };
  const fetchSecret = async () => {
    const data = {};
    create(data, "payment-methods/setup-intent")
      .then((res) => {
        setClientSecret(res?.data?.clientSecret);
        setLoading(false);
      })
      .catch((err) => {
        // console.error(err);
        // setError("Une erreur est survenue lors de l'enregistrement");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSecret();
  }, [dispatch]);
  const options = {
    clientSecret,
  };

  const handleDelete = (cardId) => {
    dispatch(deletePaymentCard(cardId))
      .unwrap()
      .then(() => {
        toast.success("Carte supprimée avec succès");
        setMessageType("success");
        setTimeout(() => {
          setMessage(null);
          setMessageType(null);
        }, 4000);
      })
      .catch((err) => {
        setMessage("Erreur lors de la suppression de la carte");
        setMessageType("error");
        setTimeout(() => {
          setMessage(null);
          setMessageType(null);
        }, 4000);
      });
  };

  return (
    <div className="payment-methods-container">
      <div className="header">
        {loading ? (
          <>
            <Skeleton
              width={220}
              height={24}
              style={{ marginBottom: "10px" }}
            />
            <Skeleton width={250} height={36} />
          </>
        ) : (
          <>
            <h3>Informations de paiement</h3>
            <button className="btn-primary" onClick={handleAddClick}>
              Ajouter une méthode de paiement
            </button>
          </>
        )}
      </div>

      {showAjoutCard && clientSecret && (
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout
            style={{
              width: "100%",
              minWidth: "100%",
              display: "block",
            }}
            className="StripeEmbeddedCheckout"
          />
        </EmbeddedCheckoutProvider>
      )}

      {loading
        ? Array(3)
            .fill(0)
            .map((_, index) => (
              <div key={index} className="payment-card mt-16">
                <div className="card-info">
                  <Skeleton width={40} height={24} />
                  <Skeleton width={180} />
                  <Skeleton width={140} />
                  <Skeleton width={80} />
                </div>
                <div className="card-actions">
                  <Skeleton width={180} height={30} />
                  <Skeleton circle width={24} height={24} />
                </div>
              </div>
            ))
        : cards.map((card, index) => (
            <div
              key={index}
              className={`payment-card mt-16 ${
                card?.is_default ? "default-payment-card" : ""
              }`}
            >
              <div className="card-info">
                <img src="/images/card.svg" alt="cardicon" />
                <p>Carte finissant par {card?.last4}</p>
                {/* <p>John Doe</p> */}
                <span className="body">
                  Exp: {card?.exp_month}/{card?.exp_year}
                </span>
              </div>
              <div className="card-actions">
                {/* {card?.is_default ? (
                       <span className="default-payment-message">
                         <img src="/images/card-check.svg" alt="card-check" />{" "}
                         Méthode de paiement utilisée par défaut
                       </span>
                     ) : (
                       <button
                         className="default-payment"
                         onClick={() => handleDefaultCard(card?.id)}
                       >
                         Utiliser comme méthode de paiement par défaut
                       </button>
                     )} */}
                <button
                  className="delete-card"
                  onClick={() => handleDelete(card?.id)}
                >
                  <img src="/images/trash.svg" alt="delete" />
                </button>
              </div>
            </div>
          ))}
    </div>
  );
};

export default PaymentMethods;
